import { TenantEntity } from '../TenantEntity'
import { saveManifestGoodsInfo, saveManifestGoodsInfoByBatch, deleteManifestGoodsInfo } from '@/api/seaExport/manifestGoodsInfo'

export class ManifestGoodsInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    this._data.sealNo = sealNo
  }
  get cargoEnglishName() {
    return this._data.cargoEnglishName
  }
  set cargoEnglishName(cargoEnglishName) {
    this._data.cargoEnglishName = cargoEnglishName
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage
  }
  get weightUnit() {
    return this._data.weightUnit
  }
  set weightUnit(weightUnit) {
    this._data.weightUnit = weightUnit
  }
  get cubageUnit() {
    return this._data.cubageUnit
  }
  set cubageUnit(cubageUnit) {
    this._data.cubageUnit = cubageUnit
  }
  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    this._data.mark = mark
  }
  get danClassNo() {
    return this._data.danClassNo
  }
  set danClassNo(danClassNo) {
    this._data.danClassNo = danClassNo
  }
  get danUNNo() {
    return this._data.danUNNo
  }
  set danUNNo(danUNNo) {
    this._data.danUNNo = danUNNo
  }
  get danPacking() {
    return this._data.danPacking
  }
  set danPacking(danPacking) {
    this._data.danPacking = danPacking
  }
  get danLable() {
    return this._data.danLable
  }
  set danLable(danLable) {
    this._data.danLable = danLable
  }
  get danPoint() {
    return this._data.danPoint
  }
  set danPoint(danPoint) {
    this._data.danPoint = danPoint
  }
  get ediStatus() {
    return this._data.ediStatus
  }
  set ediStatus(ediStatus) {
    this._data.ediStatus = ediStatus || 0
  }
  get manifestInfoUuid() {
    return this._data.manifestInfoUuid
  }
  set manifestInfoUuid(manifestInfoUuid) {
    this._data.manifestInfoUuid = manifestInfoUuid
  }
  get eqQuantity() {
    return this._data.eqQuantity
  }
  set eqQuantity(eqQuantity) {
    this._data.eqQuantity = eqQuantity
  }
  get containerLoadType() {
    return this._data.containerLoadType
  }
  set containerLoadType(containerLoadType) {
    this._data.containerLoadType = containerLoadType
  }
  get ediFeedBackState() {
    return this._data.ediFeedBackState
  }
  set ediFeedBackState(ediFeedBackState) {
    this._data.ediFeedBackState = ediFeedBackState
  }
  get ediSourceGroups() {
    return this._data.ediSourceGroups
  }
  set ediSourceGroups(ediSourceGroups) {
    this._data.ediSourceGroups = ediSourceGroups
  }
  get ediGroups() {
    return this._data.ediGroups
  }
  set ediGroups(ediGroups) {
    this._data.ediGroups = ediGroups
  }
  get ediGroups2() {
    return this._data.ediGroups2
  }
  set ediGroups2(ediGroups2) {
    this._data.ediGroups2 = ediGroups2
  }
  get soc() {
    return this._data.soc
  }
  set soc(soc) {
    this._data.soc = soc
  }
  get emptyBox() {
    return this._data.emptyBox
  }
  set emptyBox(emptyBox) {
    this._data.emptyBox = emptyBox
  }
  get dngrContactUser() {
    return this._data.dngrContactUser
  }
  set dngrContactUser(dngrContactUser) {
    this._data.dngrContactUser = dngrContactUser
  }
  get dngrContactNumber() {
    return this._data.dngrContactNumber
  }
  set dngrContactNumber(dngrContactNumber) {
    this._data.dngrContactNumber = dngrContactNumber
  }
  get email() {
    return this._data.email
  }
  set email(email) {
    this._data.email = email
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber || 0
  }
  get manifestId() {
    return this._data.manifestId
  }
  set manifestId(manifestId) {
    this._data.manifestId = manifestId
  }
  get seaHouseState() {
    return this._data.seaHouseState
  }
  set seaHouseState(seaHouseState) {
    this._data.seaHouseState = seaHouseState
  }
  get changeState() {
    return this._data.changeState
  }
  set changeState(changeState) {
    this._data.changeState = changeState
  }
  get oldContainerNo() {
    return this._data.oldContainerNo
  }
  set oldContainerNo(oldContainerNo) {
    this._data.oldContainerNo = oldContainerNo
  }
  get temp() {
    return this._data.temp
  }
  set temp(temp) {
    this._data.temp = temp
  }
  get tempUnit() {
    return this._data.tempUnit
  }
  set tempUnit(tempUnit) {
    this._data.tempUnit = tempUnit
  }
  get ventilation() {
    return this._data.ventilation
  }
  set ventilation(ventilation) {
    this._data.ventilation = ventilation
  }
  get vgmWeight() {
    return this._data.vgmWeight
  }
  set vgmWeight(vgmWeight) {
    this._data.vgmWeight = vgmWeight
  }
  get dgContactEmail() {
    return this._data.dgContactEmail
  }
  set dgContactEmail(dgContactEmail) {
    this._data.dgContactEmail = dgContactEmail
  }
  get dgContactFax() {
    return this._data.dgContactFax
  }
  set dgContactFax(dgContactFax) {
    this._data.dgContactFax = dgContactFax
  }
  get bookingNo() {
    return this._data.bookingNo
  }
  set bookingNo(bookingNo) {
    this._data.bookingNo = bookingNo
  }
  set ediSenderId(ediSenderId) {
    this._data.ediSenderId = ediSenderId
  }
  get ediSenderId() {
    return this._data.ediSenderId
  }
  set goodsRemark(goodsRemark) {
    this._data.goodsRemark = goodsRemark
  }
  get goodsRemark() {
    return this._data.goodsRemark
  }
  static async save(data) {
    return await saveManifestGoodsInfo(data).then(res => res.data)
  }
  static async saveByBatch(data) {
    return await saveManifestGoodsInfoByBatch(data)
  }
  static async delete(uuid) {
    return await deleteManifestGoodsInfo({ uuid }).then(res => res.data)
  }
}
